<template>
  <v-card dense elevation="5" class="mini-card">
    <v-card-title
        :id=    "value ? `${title}-${value}` : ''"
        ref=    "value"
        class=  "justify-center text-no-wrap"
    >
      <component :is="tag" :href="value" target="_blank">
        {{isLink ? $t('field.DOWNLOAD') : value}}
      </component>
    </v-card-title>
    <v-card-text>{{title}}</v-card-text>
  </v-card>
</template>

<script>
  import { TextFit } from '../tools'

  export default {
    name:   'MiniCard',
    props: {
      title:        String,
      value:        String,
      fitmod:       { type: String, optional: true },
      maxFontSize:  { type: Number, optional: true }
    },
    computed: {
      tag() {
        return this.isLink ? 'a' : 'span'
      },
      isLink() {
        return !!this.value.match(/^https?:\/\//)
      }
    },
    data: function(){
      return {
        linkifiedOptions: {
          format() {
            return 'Download'
          }
        }
      }
    },
    methods: {
      fitText() {
        let el = this.$refs.value
        if (el && el.id){
          el.fitmod       = this.fitmod
          el.maxFontSize  = this.maxFontSize
          TextFit(el)
        }
      }
    },
    watch:{
      "$store.state.windowWidth": {
        handler: function() {
          this.fitText()
        },
        immediate: true
      }
    },
    mounted() {
      this.fitText()
    }
  }
</script>

<style>
  .mini-card {
    background: #ffe1a8 !important
  }
</style>
